module.exports = __webpack_public_path__ + "assets/img/Affiches_006.4655fd78.jpg";